(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-drawer-close]')) this.close();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.filter.call(
          this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null; }
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cart-drawer-locked');
        if (window.FanderaCart) window.FanderaCart.drawerOpen = false;
        document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
        var cartButton = document.querySelector('[data-cart-drawer-open]');
        if (cartButton) cartButton.focus();
      });

      this._onOpenRequest = () => this.open();
      document.addEventListener('cart:open-drawer', this._onOpenRequest);
      document.addEventListener('cart:added', this._onOpenRequest);

      if (window.FanderaCart && window.FanderaCart.drawerOpen) {
        this.open();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart:open-drawer', this._onOpenRequest);
      document.removeEventListener('cart:added', this._onOpenRequest);
    }

    open() {
      if (!this.dialog || this.dialog.hasAttribute('open')) return;
      this.dialog.showModal();
      document.documentElement.classList.add('cart-drawer-locked');
      if (window.FanderaCart) window.FanderaCart.drawerOpen = true;
      document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'true');
      });
    }

    close() {
      if (!this.dialog || !this.dialog.hasAttribute('open')) return;
      this.dialog.close();
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var button = document.querySelector('[data-cookie-preferences]');
    if (!button) return;

    function bannerReady() {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    }

    if (bannerReady()) {
      button.hidden = false;
    } else {
      var attempts = 0;
      var poll = setInterval(function () {
        attempts += 1;
        if (bannerReady()) {
          button.hidden = false;
          clearInterval(poll);
        } else if (attempts >= 25) {
          clearInterval(poll);
        }
      }, 200);
    }

    button.addEventListener('click', function () {
      if (bannerReady()) {
        window.privacyBanner.showPreferences();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function setMobileMenuToggleState(toggle, isOpen) {
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    const label = toggle.querySelector('.visually-hidden');
    if (label) {
      label.textContent = isOpen ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
    }
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-drawer-open]')) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open-drawer'));
      return;
    }

    const submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
    if (submenuToggle) {
      const panel = document.getElementById(submenuToggle.getAttribute('aria-controls'));
      const isOpen = submenuToggle.getAttribute('aria-expanded') === 'true';
      submenuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) {
        panel.classList.toggle('is-open', !isOpen);
        panel.toggleAttribute('inert', isOpen);
      }
      return;
    }

    const dialog = document.getElementById('mobile-menu');
    if (!dialog) return;

    const toggle = document.querySelector('[data-mobile-menu-toggle]');

    if (event.target.closest('[data-mobile-menu-toggle]')) {
      dialog.showModal();
      document.documentElement.classList.add('mobile-menu-locked');
      setMobileMenuToggleState(toggle, true);
      return;
    }

    if (event.target.closest('[data-mobile-menu-close]') || event.target === dialog) {
      dialog.close();
    }
  });

  const mobileMenuDialog = document.getElementById('mobile-menu');

  if (mobileMenuDialog) {
    mobileMenuDialog.addEventListener('close', () => {
      document.documentElement.classList.remove('mobile-menu-locked');
      setMobileMenuToggleState(document.querySelector('[data-mobile-menu-toggle]'), false);

      document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('inert', '');
        }
      });
    });
  }

  document.querySelectorAll('[data-catalog-nav-item]').forEach((item) => {
    const toggle = item.querySelector('[data-catalog-toggle]');
    const dropdown = item.querySelector('[data-catalog-dropdown]');
    if (!toggle || !dropdown) return;

    function openDropdown() {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      if (item.classList.contains('is-open')) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    document.addEventListener('click', (event) => {
      if (!item.contains(event.target)) closeDropdown();
    });

    dropdown.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeDropdown();
    });

    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDropdown();
        toggle.focus();
      }
    });
  });

  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var mobileQuery = window.matchMedia('(max-width: 989.98px)');
    var lastScrollY = Math.max(0, window.scrollY);
    var ticking = false;
    var DELTA = 10;

    function overlayOpen() {
      var root = document.documentElement;
      return (
        root.classList.contains('mobile-menu-locked') ||
        root.classList.contains('cart-drawer-locked') ||
        root.classList.contains('team-form-locked')
      );
    }

    function show() {
      header.classList.remove('mobile-header-hidden');
    }

    function hide() {
      header.classList.add('mobile-header-hidden');
    }

    function update() {
      ticking = false;

      if (!mobileQuery.matches) {
        show();
        return;
      }

      var currentScrollY = Math.max(0, window.scrollY);

      if (overlayOpen()) {
        show();
        lastScrollY = currentScrollY;
        return;
      }

      if (currentScrollY <= 10) {
        show();
      } else if (currentScrollY > lastScrollY + DELTA) {
        hide();
      } else if (currentScrollY < lastScrollY - DELTA) {
        show();
      }

      lastScrollY = currentScrollY;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    mobileQuery.addEventListener('change', () => {
      show();
      lastScrollY = Math.max(0, window.scrollY);
    });

    header.addEventListener('focusin', () => {
      show();
      lastScrollY = Math.max(0, window.scrollY);
    });

    // Capture phase: fires for the close of any descendant <dialog>
    // (mobile menu, cart drawer) without needing to modify either of
    // their own implementations.
    document.addEventListener(
      'close',
      (event) => {
        if (event.target && event.target.tagName === 'DIALOG') {
          lastScrollY = Math.max(0, window.scrollY);
          show();
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  (function () {
    var form = document.getElementById('contact_form');
    if (!form) return;

    var state = form.querySelector('[data-contact-form-state]');
    var hasErrors = state && state.getAttribute('data-has-errors') === 'true';
    var storageKey = 'fandera-contact-form';
    var fields = form.querySelectorAll('[data-preserve-field]');

    form.addEventListener('submit', function () {
      var data = {};
      fields.forEach(function (input) {
        data[input.getAttribute('data-preserve-field')] = input.value;
      });
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(data));
      } catch (error) {
        /* sessionStorage unavailable, skip */
      }
    });

    try {
      var saved = sessionStorage.getItem(storageKey);
      if (saved && hasErrors) {
        var parsed = JSON.parse(saved);
        fields.forEach(function (input) {
          var key = input.getAttribute('data-preserve-field');
          if (!input.value && parsed[key]) {
            input.value = parsed[key];
          }
        });
      }
      if (saved) sessionStorage.removeItem(storageKey);
    } catch (error) {
      /* ignore malformed storage */
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var list = document.querySelector('[data-faq-list]');
    if (!list) return;

    list.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger) return;

      var item = trigger.closest('[data-faq-item]');
      var panel = item.querySelector('[data-faq-panel]');
      var isOpen = item.getAttribute('data-open') === 'true';

      item.setAttribute('data-open', isOpen ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.toggleAttribute('inert', isOpen);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-gallery-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.dots = Array.from(this.querySelectorAll('.product-gallery__dot'));

      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByDirection(-1));
      if (next) next.addEventListener('click', () => this.scrollByDirection(1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goToMedia(thumb.getAttribute('data-media-id')));
      });

      if (this.slides.length > 1 && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.setActive(entry.target.getAttribute('data-media-id'));
              }
            });
          },
          { root: this.viewport, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }
    }

    scrollByDirection(direction) {
      if (!this.viewport) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollBy({
        left: this.viewport.clientWidth * direction,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    goToMedia(mediaId) {
      if (!mediaId) return;
      const slide = this.slides.find((item) => item.getAttribute('data-media-id') === mediaId);
      if (!slide) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
      this.setActive(mediaId);
    }

    setActive(mediaId) {
      this.thumbs.forEach((thumb) => {
        const isActive = thumb.getAttribute('data-media-id') === mediaId;
        thumb.classList.toggle('product-gallery__thumb--active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });

      const index = this.slides.findIndex((item) => item.getAttribute('data-media-id') === mediaId);
      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('product-gallery__dot--active', dotIndex === index);
      });
    }
  }

  class ProductVariantPicker extends HTMLElement {
    connectedCallback() {
      const script = this.querySelector('[data-variant-json]');
      this.variants = script ? JSON.parse(script.textContent) : [];
      this.form = this.querySelector('[data-product-form]');
      this.variantIdInput = this.querySelector('[data-variant-id-input]');
      this.addToCartButton = this.querySelector('[data-add-to-cart]');
      this.addToCartText = this.querySelector('[data-add-to-cart-text]');
      this.formMessage = this.querySelector('[data-form-message]');
      this.availabilityStatus = this.querySelector('[data-availability-status]');
      this.fieldsets = Array.from(this.querySelectorAll('.product__option')).sort(
        (a, b) => Number(a.getAttribute('data-option-position')) - Number(b.getAttribute('data-option-position'))
      );
      this.priceEl = document.querySelector('[data-price]');
      this.stickyBar = document.querySelector('[data-sticky-bar]');
      this.stickyPrice = document.querySelector('[data-sticky-price]');
      this.stickySize = document.querySelector('[data-sticky-size]');
      this.stickyAddToCart = document.querySelector('[data-sticky-add-to-cart]');
      this.stickyAddToCartText = document.querySelector('[data-sticky-add-to-cart-text]');
      this.gallery = document.querySelector('product-gallery');
      this.addToCartLabel = this.addToCartText ? this.addToCartText.textContent.trim() : 'Añadir al carrito';

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-value]')) this.handleOptionChange();
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }
      if (this.stickyAddToCart) {
        this.stickyAddToCart.addEventListener('click', (event) => {
          if (this.stickyAddToCart.disabled) return;
          event.preventDefault();
          this.addToCart();
        });
      }

      this.refreshUnavailableStates();
      this.updateSizeLabel();
    }

    getSelectedOptions() {
      return this.fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('[data-option-value]:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(options) {
      return this.variants.find((variant) => variant.options.length === options.length && variant.options.every((value, index) => value === options[index]));
    }

    handleOptionChange() {
      const options = this.getSelectedOptions();
      const variant = this.findVariant(options);
      this.refreshUnavailableStates();
      this.updateSizeLabel();

      if (!variant) return;

      if (this.variantIdInput) this.variantIdInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;
      if (this.stickyPrice) this.stickyPrice.textContent = variant.price;

      const available = variant.available;
      [this.addToCartButton, this.stickyAddToCart].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
      });
      const label = available ? this.addToCartLabel : 'Agotado';
      if (this.addToCartText) this.addToCartText.textContent = label;
      if (this.stickyAddToCartText) this.stickyAddToCartText.textContent = label;
      if (this.availabilityStatus) {
        this.availabilityStatus.textContent = available ? 'Disponible' : 'Agotado';
      }

      if (variant.featured_image_id && this.gallery && typeof this.gallery.goToMedia === 'function') {
        this.gallery.goToMedia(String(variant.featured_image_id));
      }

      if (this.form && this.form.action) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    refreshUnavailableStates() {
      const selected = this.getSelectedOptions();
      this.fieldsets.forEach((fieldset, position) => {
        const inputs = Array.from(fieldset.querySelectorAll('[data-option-value]'));
        inputs.forEach((input) => {
          const candidate = selected.slice();
          candidate[position] = input.value;
          const match = this.findVariant(candidate);
          const label = input.nextElementSibling;
          if (!match) {
            input.disabled = true;
            if (label) label.classList.remove('product__option-label--soldout');
          } else {
            input.disabled = false;
            if (label) label.classList.toggle('product__option-label--soldout', !match.available);
          }
        });
      });
    }

    updateSizeLabel() {
      if (!this.stickySize) return;
      const sizeFieldset = this.fieldsets[0];
      const checked = sizeFieldset ? sizeFieldset.querySelector('[data-option-value]:checked') : null;
      this.stickySize.textContent = checked ? checked.value : '';
    }

    async handleSubmit(event) {
      event.preventDefault();
      await this.addToCart();
    }

    async addToCart() {
      if (!this.variantIdInput || !window.FanderaCart) return;
      const variantId = this.variantIdInput.value;
      this.setLoading(true);
      this.hideMessage();

      const result = await window.FanderaCart.add(variantId, 1);
      if (!result.ok) {
        this.showMessage(result.message || 'No se ha podido añadir el producto al carrito. Inténtalo de nuevo.');
      } else {
        this.flashAdded();
      }
      this.setLoading(false);
    }

    flashAdded() {
      [this.addToCartButton, this.stickyAddToCart].forEach((button) => {
        if (!button) return;
        button.dataset.added = 'true';
        window.setTimeout(() => {
          delete button.dataset.added;
        }, 900);
      });
    }

    setLoading(isLoading) {
      [this.addToCartButton, this.stickyAddToCart].forEach((button) => {
        if (button) button.disabled = isLoading || button.disabled;
      });
      if (isLoading && this.addToCartText) this.addToCartText.textContent = 'Añadiendo…';
      if (isLoading && this.stickyAddToCartText) this.stickyAddToCartText.textContent = 'Añadiendo…';
    }

    showMessage(message) {
      if (!this.formMessage) return;
      this.formMessage.textContent = message;
      this.formMessage.hidden = false;
    }

    hideMessage() {
      if (!this.formMessage) return;
      this.formMessage.hidden = true;
      this.formMessage.textContent = '';
    }
  }

  customElements.define('product-gallery', ProductGallery);
  customElements.define('product-variant-picker', ProductVariantPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProductsLoader extends HTMLElement {
    connectedCallback() {
      const url = this.getAttribute('data-url');
      const targetId = this.getAttribute('data-target');
      if (!url || !targetId) return;

      fetch(url)
        .then((response) => (response.ok ? response.text() : null))
        .then((html) => {
          if (!html) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const fetched = parsed.getElementById(targetId);
          const current = document.getElementById(targetId);
          if (fetched && current && fetched.children.length > 0) {
            current.replaceWith(fetched);
          }
        })
        .catch(() => {
          /* keep the server-rendered fallback grid */
        });
    }
  }

  customElements.define('related-products-loader', RelatedProductsLoader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-request-modal"]) return;
  try {
    
  (function () {
    var dialog = document.getElementById('team-request-modal');
    if (!dialog) return;

    var closeButton = dialog.querySelector('[data-team-form-close]');
    var panel = dialog.querySelector('[data-team-form-panel]');
    var success = dialog.querySelector('[data-team-form-success]');
    var form = document.getElementById('team-request-form');
    var errorBox = dialog.querySelector('[data-team-form-error]');
    var submitButton = dialog.querySelector('[data-team-form-submit]');
    var bodyField = dialog.querySelector('[data-team-form-body]');
    var teamField = dialog.querySelector('[data-team-form-team]');
    var descriptionField = dialog.querySelector('[data-team-form-description]');

    function openModal() {
      if (dialog.hasAttribute('open')) return;
      dialog.showModal();
      document.documentElement.classList.add('team-form-locked');
    }

    function closeModal() {
      if (!dialog.hasAttribute('open')) return;
      dialog.close();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[href="#pide-tu-equipo"]');
      if (!trigger) return;
      event.preventDefault();

      var mobileMenu = document.getElementById('mobile-menu');
      if (mobileMenu && mobileMenu.hasAttribute('open')) {
        mobileMenu.close();
      }

      openModal();
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeModal();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('team-form-locked');
    });

    if (form && bodyField) {
      form.addEventListener('submit', function (event) {
        var team = teamField ? teamField.value.trim() : '';
        var description = descriptionField ? descriptionField.value.trim() : '';
        bodyField.value =
          'Solicitud nuevo equipo FANDERA\n\n' +
          'Equipo: ' + team + '\n\n' +
          'Qué le gustaría ver: ' + (description || '(sin detalles)');

        if (!window.fetch) return; // let it submit natively as a fallback

        event.preventDefault();
        if (errorBox) errorBox.hidden = true;
        if (submitButton) submitButton.setAttribute('aria-busy', 'true');

        var formData = new FormData(form);

        fetch(form.action, { method: 'POST', body: formData })
          .then(function (response) {
            if (submitButton) submitButton.removeAttribute('aria-busy');

            if (response.redirected) {
              form.reset();
              if (panel) panel.setAttribute('hidden', '');
              if (success) {
                success.removeAttribute('hidden');
                success.focus({ preventScroll: true });
              }
            } else {
              if (errorBox) errorBox.hidden = false;
            }
          })
          .catch(function () {
            if (submitButton) submitButton.removeAttribute('aria-busy');
            if (errorBox) errorBox.hidden = false;
          });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
